import { useEffect, useState } from "react";
import { useDevice } from "../../../common/hooks/useDevice";
import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomTextCard from "../../../common/components/card/CustomTextCard";
import styled from "styled-components";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import Translate from "../../../common/translate/Translate";
import { C2Text, T1Text, T3Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import CustomPercentCircleChart from "../../../common/components/chart/CustomPercentCircleChart";
import { Theme } from "../../../common/Theme";
import RevenueService from "../../../service/RevenueService";
import { format, subDays } from "date-fns";

const TabletTextCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 17px;
    height: 357px;
`;

const WebTextCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 17px;
    height: 170px;
`;

function AdminDashboardTextCardArea() {
    const { width } = useWindowSize();
    const currentDevice = useDevice();
    const revenueService = new RevenueService();

    const [deviceData, setDeviceData] = useState({
        total: 0,
        active: 0,
        notAvailable: 0,
        freeCycle: 0,
    });

    const fetchUsageDevice = () => {
        const endDate = format(new Date(), "yyyy-MM-dd");
        const startDate = format(subDays(new Date(), 7), "yyyy-MM-dd");
        revenueService
            .getUsageDevice({ startDate, endDate })
            .then((result) => {
                // 응답 키는 totalDevice/activeDevice/notAvailableDevice/freeCycle 이며 각각 {total,washer,dryer,combo}
                setDeviceData({
                    total: result?.totalDevice?.total || 0,
                    active: result?.activeDevice?.total || 0,
                    notAvailable: result?.notAvailableDevice?.total || 0,
                    freeCycle: result?.freeCycle?.total || 0,
                });
            })
            .catch((error) => {
                console.error("Error fetching usage device:", error);
            });
    };

    useEffect(() => {
        fetchUsageDevice();
    }, []);

    const workingPercentage =
        deviceData.total > 0 ? Math.round((deviceData.active / deviceData.total) * 100) : 0;
    const errorCount = deviceData.total - deviceData.active - deviceData.notAvailable - deviceData.freeCycle;
    const vacantCount = deviceData.freeCycle;

    const currentWorkingCard = (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"100%"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={Theme.color.indigo600}
        >
            <Row justifyContent={"space-between"} alignItem={"flex-start"} width={"100%"}>
                <Column justifyContent={"flex-start"} alignItem={"flex-start"} width={"50%"}>
                    <SizedBox
                        backgroundColor={Theme.color.neutral100_01}
                        width={"40px"}
                        height={"40px"}
                        borderRadius={"100%"}
                    >
                        <CustomIcon iconName={"refresh_white"} size={"24px"} />
                    </SizedBox>
                    <SizedBox height={"36px"} />
                    <C2Text fontColor={Theme.color.neutral100}>Currently Working</C2Text>
                    <SizedBox height={"6px"} />
                    <Row alignItem={"flex-end"}>
                        <T1Text fontColor={Theme.color.neutral100}>{deviceData.active}</T1Text>
                        <SizedBox width={"7px"} />
                        <T3Text fontColor={Theme.color.neutral300} lineHeight={1.5}>
                            /{deviceData.total}
                        </T3Text>
                    </Row>
                </Column>
                <SizedBox width={"10px"} />
                <Column justifyContent={"center"} height={"100%"}>
                    <CustomPercentCircleChart size={100} percentage={workingPercentage} strokeWidth={10} />
                </Column>
            </Row>
        </SizedBox>
    );

    const totalDailyTransactionsCard = (
        <CustomTextCard
            icon={"alert_triangle"}
            title={"Error"}
            mainContent={String(errorCount >= 0 ? errorCount : 0)}
            remainCount={String(deviceData.total)}
            hasIcon={true}
        />
    );

    const currentlyWorkingCard = (
        <CustomTextCard
            icon={"green_loader"}
            title={Translate("dashboard.vacant")}
            mainContent={String(vacantCount)}
            remainCount={String(deviceData.total)}
            hasIcon={true}
        />
    );

    const vacantCard = (
        <CustomTextCard
            icon={"black_out_grey"}
            title={"Not Available"}
            mainContent={String(deviceData.notAvailable)}
            remainCount={String(deviceData.total)}
            hasIcon={true}
        />
    );

    if (currentDevice === "mobile") {
        return (
            <>
                <SizedBox height={"20px"} />
                {currentWorkingCard}
                <SizedBox height={"16px"} />
                {totalDailyTransactionsCard}
                <SizedBox height={"16px"} />
                {currentlyWorkingCard}
                <SizedBox height={"16px"} />
                {vacantCard}
            </>
        );
    } else if (width <= 1400) {
        return (
            <>
                <SizedBox height={"24px"} />
                <TabletTextCardGrid>
                    {currentWorkingCard}
                    {totalDailyTransactionsCard}
                    {currentlyWorkingCard}
                    {vacantCard}
                </TabletTextCardGrid>
            </>
        );
    } else {
        return (
            <>
                <SizedBox height={"24px"} />
                <WebTextCardGrid>
                    {currentWorkingCard}
                    {totalDailyTransactionsCard}
                    {currentlyWorkingCard}
                    {vacantCard}
                </WebTextCardGrid>
            </>
        );
    }
}

export default AdminDashboardTextCardArea;
